import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { session } from 'src/environments/environment.session';
import { KlManageService } from '../service/kl-manage.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-klm-booking',
  templateUrl: './klm-booking.component.html',
  styleUrls: ['./klm-booking.component.css']
})
export class KlmBookingComponent {
  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer, private klmanageservice: KlManageService) { }

  page_flag: any = true
  list_flag: any = true
  ebillUser: any;
  b_acct_id: any;
  datasource: any
  displayedColumns: any = ['si_no', 'applicant_name', 'kalyan_mandap_name', 'address', 'booking_date', 'check_out_date', 'total_payble_amt', 'action'];
  displayedmunciplEmpColumns: any = ['si_no', 'applicant_name', 'kota', 'emp_id', 'kalyan_mandap_name', 'address', 'booking_date', 'status', 'action'];

  view_book_flag: any = false
  @ViewChild('paginator0', { static: false }) paginator0!: MatPaginator;
  @ViewChild('sortCol0', { static: false }) sortCol0!: MatSort;
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    await this.getbookingdata('NO')

  }

  table_data: any = []

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
  open_create() {
    this.list_flag = false

  }


  async getbookingdata(element: any) {
    let obj: any = {}
    obj["b_acct_id"] = this.ebillUser.b_acct_id
    obj['is_muncipl_emp'] = element
    let resp = await this.klmanageservice.getklmbookingdata(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      let j = 1
      for (let i = 0; i < resp['data'].length; i++) {
        resp['data'][i]['new_index'] = j + i
      }


      this.datasource = new MatTableDataSource(resp['data'])
      this.datasource.paginator = this.paginator0;
      this.datasource.sort = this.sortCol0;
    }
  }




  vendorDetails: any = {}
  view_application_flag: boolean = false;
  async open_application(data: any) {
    // this.spinner.show();
    // this.vendorDetails = null;
    // this.view_application_flag = true
    // this.list_flag = false
    // this.vendorDetails = data
    // const words = this.vendorDetails['party_name'].split(" ");
    // console.log(words)
    // let obj: any = {};
    // obj['party_id'] = this.vendorDetails['party_id']
    // obj['doc_name'] = this.vendorDetails['profile_img_doc']
    // obj['b_acct_id'] = this.b_acct_id
    // await this.viewdoc(obj);
    // await this.get_family_info();
    // this.spinner.hide();
  }

  toggleHoverText(event: Event) {
    const target = event.target as HTMLElement;
    const hoverText = target.nextElementSibling as HTMLElement;
    hoverText.classList.toggle('show');
  }

  booking_data: any = []

  async view_booking_dtls(element: any) {

    let obj: any = {}
    obj = Object.assign({}, element)
    obj["b_acct_id"] = this.b_acct_id

    let resp = await this.klmanageservice.getbookingdtls(JSON.stringify(obj))
    console.log(resp)
    let resp1 = await this.klmanageservice.getbookingimage(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      if (resp.data.length > 0) {

        this.view_book_flag = true
        this.booking_data = []
        this.booking_data = resp['data']
      }
      else {
        Swal.fire('Info', "No Data Found", 'info')
      }
    }
    if (resp1["error"] == false) {
      await this.getImageUrl(resp1['data'])
    }
  }

  imgURL1: any;
  sanitizedImageUrls: any = [];
  date_flag: any = false

  async getImageUrl(documents: any[]) {
    try {
      // Map the documents to promises
      const promises: Promise<SafeResourceUrl | null>[] = documents.map(async (document: any) => {
        document['b_acct_id'] = this.b_acct_id;

        try {
          // Fetch the document
          const resp = await this.klmanageservice.getdocument(document);

          if (resp) {
            // Get the file extension
            const docname = document["doc_name"];
            const ext = docname.split('.').pop().toLowerCase();

            // Create a blob URL
            const unsafeImageUrl = window.URL.createObjectURL(resp);

            // Sanitize the URL based on the file extension
            let sanitizedUrl: SafeResourceUrl;
            if (['png', 'jpeg', 'jpg'].includes(ext)) {
              sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeImageUrl);
            } else {
              sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
            }

            // Return the sanitized URL
            return sanitizedUrl;
          } else {
            // Return null if the response is falsy
            return null;
          }
        } catch (error) {
          console.error('Error fetching document:', error);
          // Return null in case of an error
          return null;
        }
      });

      console.log(promises);

      // Wait for all promises to resolve
      this.imgURL1 = await Promise.all(promises);

      console.log(this.imgURL1);
    } catch (error) {
      console.error('Error in getImageUrls:', error);
    }
  }

  view_book_klm_flag: any = false
  async view_kalyan_mandap(element: any) {

    let obj: any = {}
    obj = Object.assign({}, element)
    obj["b_acct_id"] = this.b_acct_id

    let resp = await this.klmanageservice.getbookingdtls(JSON.stringify(obj))
    console.log(resp)
    let resp1 = await this.klmanageservice.getbookingimage(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      if (resp.data.length > 0) {

        this.view_book_klm_flag = true

        this.booking_data = []
        this.booking_data = resp['data']
      }
      else {
        Swal.fire('Info', "No Data Found", 'info')
      }
    }
    if (resp1["error"] == false) {
      await this.getImageUrl(resp1['data'])
    }
  }

  export() {

  }
  goback_to_list() {
    this.view_book_flag = false
    this.list_flag = true
  }
}
